import BarChart from './BarChart.jsx';

function VrpChart({ data }) {
  const options = {
    xaxis: {
      categories: [
        '2008',
        '2009',
        '2010',
        '2011',
        '2012',
        '2013',
        '2014',
        '2015',
        '2016',
        '2017',
        '2018',
        '2019',
        '2020',
        '2021',
        '2022',
        '2023',
        '2024',
        '2025',
      ],
    },
  };

  const series = [
    {
      name: 'ВРП',
      data,
    },
  ];

  return (
    <BarChart
      series={series}
      options={options}
      title="ВРП по годам, млн тенге"
    />
  );
}

export default VrpChart;
